export default "__VITE_ASSET__DdqwAzaP__"